<template>
<div class="row" v-if="exibe">
    <div class="col-md-12">
                    
        <button class="btn btn-xs no-print btn-default" type="button" @click="_print()" style="margin-bottom: 10px">
            <i class="fa icon-imprimir r-print"></i> {{_traducao('global','imprimir').toUpperCase()}}
        </button>

        <button class="btn btn-xs no-print pull-right btn-default" type="button" @click="$emit('volta-lista')" style="margin-bottom: 10px">
            <i class="fa icon-left r-print"></i> {{_traducao('global','voltar').toUpperCase()}}
        </button>

        <div style="border:10px solid red; padding:10px; min-height: 1000px;">
            <div class="row">
                <div class="col-xs-3 text-center" style="padding:0px">
                    <img :src="_img2" style="width:100px;margin-top:8px">
                </div>
                <div class="col-xs-6 text-center" style="padding:0px;vertical-align: middle;">
                    <h5>{{_titulo}}</h5>
                    <h2 style="color: red !important; margin:0px">- RELPREV -</h2>
                    <h4 style="margin:0px; margin-top:10px; margin-bottom:10px">{{_labelRelatorioPrevencao.titulo.toUpperCase()}}</h4>
                </div>
                <div class="col-xs-3 text-center" style="padding:0px;">
                    <img :src="_img1"  style="width:104px;margin-top:14px">
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 text-center">
                    <div  style="border: 2px solid #333">
                        <p style="margin-top:16px; margin-bottom:16px">
                        <strong>{{_traducao('menuAGprevencao','menuAGrelatoOcorrencia')}}</strong>
                        </p>
                    </div>
                </div>
            </div>

            <div class="row" style="margin-top:20px">
                <div class="col-md-12">
                    <div  style="border: 2px solid #333; padding: 10px">
                        <div class="row">
                            <div class="col-xs-8">
                                <label>{{_traducao('menuAGpermutas','menuAGcidade').toUpperCase()}}:</label> {{relatorio.cidade.toUpperCase()}}
                            </div>
                            <div class="col-xs-4 ">
                                <label>{{_traducao('menuAGpermutas','menuAGestado').toUpperCase()}}:</label> {{relatorio.estado.toUpperCase()}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label>{{_traducao('menuAGpermutas','menuAGlocal').toUpperCase()}}:</label> {{relatorio.local}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label>{{_traducao('global','evento').toUpperCase()}}:</label> {{relatorio.descricao_evento}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label>{{_traducao('menuAGpermutas','menuAGdata').toUpperCase()}}:</label> {{relatorio.data}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label>{{_traducao('menuAGpermutas','menuAGenvolvidos').toUpperCase()}}:</label> {{relatorio.envolvidos}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label>{{_traducao('menuAGpermutas','menuAGaeronave').toUpperCase()}}:</label> {{relatorio.codinome}} - {{relatorio.prefixo}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" style="margin-top: 20px">
                <div class="col-md-12">
                    <p><STRONG>{{_traducao('menuAGpermutas','menuAGsituacao').toUpperCase()}}:</STRONG> {{relatorio.descricao}} </p>
                </div>
            </div>

            <div class="row" v-show="relatorio.conclusao != null" style="margin-top: 10px">
                <div class="col-md-12">
                    <p><STRONG>{{_traducao('menuAGpermutas','menuAGconclusao').toUpperCase()}}:</STRONG> {{relatorio.conclusao}} </p>
                </div>
            </div>

            

            <div class="row" style="margin-top:20px">
                <div class="col-md-12">
                    <div style="border: 2px solid #333; padding:10px">
                        <div class="row">
                            <div class="col-md-12">
                                <label>{{_traducao('menuAGpermutas','menuAGnome').toUpperCase()}}:</label> {{relatorio.relator}}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-8">
                                <label>{{_traducao('menuAGpermutas','menuAGemail').toUpperCase()}}:</label> {{relatorio.email}}
                            </div>
                            <div class="col-xs-4">
                                <label>{{_traducao('menuAGpermutas','menuAGtel').toUpperCase()}}:</label> {{relatorio.telefone}}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
    
export default {
	
	data (){
		return {
			relatorio : {},
			exibe: false,
		}
	},

	mounted (){
		var self = this
		bus.$on('carrega-prevencao', function(id){
			self.carregar(id)
		})
	},

	methods: {

		carrega (id){
			this.carregar(id)
		},

		carregar (id){

			bus.$emit('load-in', {text: this._traducao('global','carregando')})
			this._httpGet(`/Relatorio_prevencao/get_relatorio_prevencao/${id}`, (retorno) => {
				bus.$emit('load-out')
				if(retorno._request && retorno._status){
					this.exibe = true
					this.relatorio = retorno.relatorio_prevencao
					this.relatorio.data = this._SQLDateToDateTime(this.relatorio.data, $sessao.getDateFormat() + " HH:MM:SS")
				}
			})
		},
	}
}
</script>